var _style, _defs, _g, _g2, _g3, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gp-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes draw-1l {\n      0% {\n        stroke-dashoffset: 47;\n      }\n      12.5%, 100% {\n        stroke-dashoffset: 0;\n      }\n    }\n\n    @keyframes draw-1r {\n      0% {\n        stroke-dashoffset: 47;\n      }\n      12.5%, 100% {\n        stroke-dashoffset: 0;\n      }\n    }\n\n    @keyframes draw-2l {\n      0%, 12.5% {\n        stroke-dashoffset: 26;\n      }\n      25%, 100% {\n        stroke-dashoffset: 0;\n      }\n    }\n\n    @keyframes draw-2r {\n      0%, 12.5% {\n        stroke-dashoffset: 77;\n      }\n      25%, 100% {\n        stroke-dashoffset: 0;\n      }\n    }\n\n    @keyframes move-head {\n      0%, 12.5% {\n        transform: translateY(30px) scale(.5);\n        opacity: 0;\n      }\n      33%, 100% {\n        transform: none;\n        opacity: 1;\n      }\n    }\n\n    #gp-logo #path-1l {\n      stroke-dasharray: 47;\n      stroke-dashoffset: 47;\n      animation: draw-1l 4s ease-in both;\n    }\n\n    #gp-logo #path-1r {\n      stroke-dasharray: 47;\n      stroke-dashoffset: 47;\n      animation: draw-1r 4s ease-in both;\n    }\n\n    #gp-logo #path-2l {\n      stroke-dasharray: 26;\n      stroke-dashoffset: 26;\n      animation: draw-2l 4s ease-out both;\n    }\n\n    #gp-logo #path-2r {\n      stroke-dasharray: 77;\n      stroke-dashoffset: 77;\n      animation: draw-2r 4s ease-out both;\n    }\n\n    #gp-logo #people-head {\n      transform-origin: 35.49px 22.57px;\n      animation: move-head 4s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "gp-mask",
    x: 4.059,
    y: 4.799,
    width: 79.314,
    height: 81.753,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1r",
    d: "M35.411,39.408,52.686,82.117",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2r",
    d: "M53.084,81.686,78.613,9.557",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1l",
    d: "M34.773,38.757,18.384,82.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2l",
    d: "M17.693,81.329,9.059,57.537",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-linear-gradient",
    x1: 43.86,
    y1: 86.354,
    x2: 43.86,
    y2: 4.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#346ab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#2f7ba8",
    stopOpacity: 0.989
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#22a891",
    stopOpacity: 0.959
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1eb68a",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-linear-gradient-2",
    x1: 35.49,
    y1: 29,
    x2: 35.49,
    y2: 16.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#339fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#28ab95",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1eb68a",
    stopOpacity: 0.95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.912,28.119V25.7h8.3V40.459q-1.273.262-4.479.68a42.647,42.647,0,0,1-5.313.418q-6.588,0-9.134-3.865T95.738,25.968a36.2,36.2,0,0,1,.528-6.675,14.513,14.513,0,0,1,1.843-4.918q2.5-4.216,9.266-4.216a43.683,43.683,0,0,1,8.388.834l1.448.308-.132,2.327a53.519,53.519,0,0,0-9.484-1.01q-5.314,0-7.18,3.184T98.549,25.924q0,6.939,1.866,10.055t7.136,3.119a39.416,39.416,0,0,0,6.981-.7V28.119Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.49,41.117V19.161h2.591v3.162a24.087,24.087,0,0,1,3.975-2.2,18.736,18.736,0,0,1,4.325-1.4v2.634a24.586,24.586,0,0,0-3.952,1.208,31.263,31.263,0,0,0-3.2,1.427l-1.143.659V41.117Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.884,30.1q0-6.192,2.086-8.783t7.114-2.591q5.028,0,7.113,2.591t2.086,8.783q0,6.19-1.91,8.826T146.1,41.557q-5.358,0-7.289-2.635T136.884,30.1Zm2.722-.067q0,5.2,1.208,7.2t5.27,2q4.06,0,5.291-2.02t1.229-7.18q0-5.158-1.382-7.069T146.1,21.049q-3.732,0-5.115,1.889T139.606,30.029Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,19.161h2.679l4.83,19.673h.615L172.629,19.6H175.4L181.1,38.834h.659l4.83-19.673h2.678l-5.488,21.956h-4.567l-5.182-18.092-5.225,18.092h-4.523Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.014,13.672V10.379h2.59v3.293Zm0,27.445V19.161h2.59V41.117Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.782,41.117h-2.591V19.161h2.591v1.625a14.638,14.638,0,0,1,7.158-2.064q4.39,0,5.863,2.327t1.47,8.519V41.117h-2.634V29.7q0-5.049-.966-6.828t-4.128-1.779a12.251,12.251,0,0,0-3.228.462,13.46,13.46,0,0,0-2.612.943l-.923.44Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.381,44.454q0,3.732-2.394,5.4t-7.443,1.669q-5.049,0-6.981-1.449t-1.933-5.313a5.036,5.036,0,0,1,.791-2.964,12.383,12.383,0,0,1,2.766-2.569q-1.1-.7-1.1-2.986a8.149,8.149,0,0,1,1.054-2.766l.351-.66q-3.6-1.491-3.6-6.629,0-7.466,7.948-7.466a16.026,16.026,0,0,1,3.952.439l.658.132,6.367-.132v2.327l-4.39-.088q1.579,1.581,1.581,5.2t-2,5.27q-2,1.647-6.3,1.647a12.625,12.625,0,0,1-2.239-.176,10.61,10.61,0,0,0-.879,2.722q0,1.449.856,1.779a21.82,21.82,0,0,0,5.116.351q4.258.023,6.039,1.274T244.381,44.454Zm-16.116.132q0,2.636,1.317,3.645t5.094,1.01q3.776,0,5.4-1.076a4,4,0,0,0,1.625-3.6q0-2.524-1.185-3.271t-4.524-.747l-4.962-.175a8.656,8.656,0,0,0-2.195,2A3.92,3.92,0,0,0,228.265,44.586Zm.307-18.421q0,2.834,1.23,4t4.149,1.164q2.921,0,4.151-1.142t1.229-4.018q0-2.875-1.229-4.061t-4.151-1.186q-2.921,0-4.149,1.207A5.507,5.507,0,0,0,228.572,26.165Z",
    fill: "#302e3d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.6,73.658h-6.148v9.354H96.572V52.932H107.6q10.23,0,10.231,10.1,0,5.183-2.569,7.905T107.6,73.658Zm-6.148-4.216h6.1q5.268,0,5.269-6.411a6.547,6.547,0,0,0-1.273-4.478,5.144,5.144,0,0,0-4-1.406h-6.1Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.586,79.06l1.229-.132.088,3.556a45.435,45.435,0,0,1-8.87,1.011q-4.875,0-7-2.679T120.9,72.253q0-11.679,9.529-11.681,9.22,0,9.221,10.057l-.307,3.425H125.729a6.015,6.015,0,0,0,1.186,4q1.141,1.273,4.26,1.273T137.586,79.06Zm-2.635-8.7q0-3.249-1.032-4.545a4.218,4.218,0,0,0-3.491-1.3,4.375,4.375,0,0,0-3.579,1.362,7.24,7.24,0,0,0-1.163,4.479Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.468,63.427q2.262-2.854,7.531-2.855t7.531,2.855q2.261,2.854,2.261,8.563T160.6,80.6q-2.2,2.9-7.6,2.9t-7.6-2.9q-2.2-2.9-2.195-8.607T145.468,63.427ZM149.047,77.7q1.01,1.757,3.952,1.757t3.952-1.757q1.01-1.756,1.01-5.752t-1.075-5.665q-1.077-1.668-3.887-1.669t-3.886,1.669q-1.076,1.671-1.076,5.665T149.047,77.7Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.534,92.453v-31.4h4.742v1.361a11.027,11.027,0,0,1,5.665-1.845q4.347,0,6.368,2.657t2.019,8.915q0,6.256-2.305,8.8T176.492,83.5a25.809,25.809,0,0,1-4.172-.4v9.353Zm9.572-27.621a10.051,10.051,0,0,0-4.127.922l-.659.308V79.016a19.757,19.757,0,0,0,3.865.351q2.985,0,4.128-1.713t1.141-5.84Q181.454,64.832,177.106,64.832Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.378,83.012V51.922h4.786v31.09Z",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.856,79.06l1.23-.132.088,3.556A45.435,45.435,0,0,1,210.3,83.5q-4.875,0-7-2.679t-2.129-8.563q0-11.679,9.528-11.681,9.222,0,9.222,10.057l-.308,3.425H206a6.01,6.01,0,0,0,1.186,4q1.14,1.273,4.259,1.273T217.856,79.06Zm-2.634-8.7q0-3.249-1.033-4.545a4.215,4.215,0,0,0-3.491-1.3,4.377,4.377,0,0,0-3.579,1.362,7.24,7.24,0,0,0-1.163,4.479Z",
    fill: "#302e3d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gp-mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.464,83.268a4.888,4.888,0,0,1-1.953,2.425,4.913,4.913,0,0,1-7.039-2.425L33.564,46l2.366.354L22.442,83.268A4.415,4.415,0,0,1,18.3,86.344a4.906,4.906,0,0,1-2.958-.651,5.226,5.226,0,0,1-2.011-2.425L4.7,59.618a5.363,5.363,0,0,1-.354-1.893,4.891,4.891,0,0,1,1.3-3.431A4.572,4.572,0,0,1,9.2,52.875a4.966,4.966,0,0,1,2.6.709,3.847,3.847,0,0,1,1.657,2.367L19.6,73.684l-2.485-.119L30.842,38.071a4.565,4.565,0,0,1,4.5-2.959,4.275,4.275,0,0,1,2.662.77,4.432,4.432,0,0,1,1.479,2.189L53.915,73.565l-2.958.237L74.136,7.875c.687-2.087,2.13-3.076,4.5-3.076a4.547,4.547,0,0,1,3.254,1.3,4.172,4.172,0,0,1,1.478,3.555,3.462,3.462,0,0,1-.176,1",
    fill: "url(#gp-linear-gradient)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "people-head",
    cx: 35.49,
    cy: 22.57,
    r: 6.429,
    fill: "url(#gp-linear-gradient-2)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimated);
export default __webpack_public_path__ + "static/media/logo-animated.1c9d8ded254d9fdb1cd5b567941b3aef.svg";
export { ForwardRef as ReactComponent };